<div class="countdown">
    <div class="countdown-items">
        <div class="countdown-items-item countdown-items-item--days">
            <span class="countdown-items-item-value">{{days}}</span>
            <span class="countdown-items-item-caption">Dage</span>
            <span class="countdown-items-item-progress" [style.width.%]="this.hLineWidth"></span>
        </div>
        <div class="countdown-items-item countdown-items-item--hours">
            <span class="countdown-items-item-value">{{hours}}</span>
            <span class="countdown-items-item-caption">Timer</span>
            <span class="countdown-items-item-progress" [style.width.%]="this.mLineWidth"></span>
        </div>
        <div class="countdown-items-item countdown-items-item--minutes">
            <span class="countdown-items-item-value">{{minutes}}</span>
            <span class="countdown-items-item-caption">Minutter</span>
            <span class="countdown-items-item-progress" [style.width.%]="this.sLineWidth"></span>
        </div>

        <!-- <div class="countdown-items-item countdown-items-item--seconds" *ngIf="showSecondsBlock" >
            <span class="countdown-items-item-value">{{seconds}}</span>
            <span class="countdown-items-item-caption">Sekunder</span>
            <span class="countdown-items-item-progress"></span>
        </div> -->
    </div>
</div>
